<template>
  <article class="template-card">
    <div
      class="cover-container"
      :style="{ 'background-image': 'url(' + template.cover + ')' }"
    ></div>

    <div class="info-container">
      <h2 class="forza-bold">{{ template.title }}</h2>
      <p><span>Perfect for:</span> {{ template.subtitle }}</p>
      <a class="btn" :href="createSnapsheetRedirectRoute" target="_blank">Use this template</a>
    </div>
  </article>
</template>

<script>
export default {
  name: "SnapsheetsTemplatesItem",

  props: ["template"],

  computed: {
    createSnapsheetRedirectRoute() {
      const url = `https://www.foundersport.com/gameplan?route=create_project&type=snapsheet&snapsheet_template=${this.template.id}`;
      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
.template-card {
  display: flex;
  flex-direction: column;
  height: 400px;
  /* align-items: center; */
  border: 1px solid $borderColor;
  border-radius: 6px;

  .cover-container {
    background-color: #efefef;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-origin: padding-box;
    display: flex;
    width: 100%;
    height: 75%;
    margin-top: auto;
  }

  .info-container {
    padding: 1rem;
    padding-left: 1.5rem;
    h2 {
      text-transform: uppercase;
      font-size: 1.3rem;
      margin-bottom: 1rem;
    }
    p {
      margin-bottom: 1.5rem;
      span {
        text-transform: uppercase;
      }
    }

    img {
      width: auto;
      max-height: 50%;
      margin: auto;
    }
    a.btn {
      padding: 1rem;
      display: block;
      background: var(--snapsheetColorActive);
      color: white;
      text-transform: uppercase;
      font-size: 1rem;
      width: fit-content;
      /* margin: auto; */

      &:hover {
        background: var(--snapsheetColorHover);
      }
    }
  }
}
</style>